import cx from 'clsx';

import { PlainModal } from '@/components/modals/plain-modal';

import { MODAL_TITLE } from './constants';
import styles from './styles.module.scss';
import type { Component } from './types';

export const LaneKeepAssistModal: Component = ({
  isOpen,
  onClose,
}) => (
  <PlainModal
    className={styles.containerLaneKeepAssistModal}
    contentClassName={cx(
      styles.containerContent,
      styles.isFullWidth,
    )}
    isOpen={isOpen}
    modalTitle={MODAL_TITLE}
    onClose={onClose}>
    <div>
      Provides steering and/or braking assist to keep vehicle in its lane.
    </div>
  </PlainModal>
);
